$(document).ready(function() {
  const uploadReceipt = document.querySelector('#topup-confirm-upload')
  if (uploadReceipt) {
    let list, oldFiles;

    // HANDLE CALCULATION MULTIPLE UPLOAD
    uploadReceipt.addEventListener('focusin', e => {
      list = new DataTransfer();
      oldFiles = e.target.files;
      if (e.target.multiple) {
        [...e.target.files].forEach((oldFile) => {
          list.items.add(oldFile)
        })
      }
    })
    // HANDLE CALCULATION MULTIPLE UPLOAD

    uploadReceipt.addEventListener('change', e => {
      // FOR SINGLE UPLOAD, CLEAR TEMPLATE FIRST
      if (!e.target.multiple) {
        document.querySelectorAll('#receipt-list div.receipt-itm').forEach(function (elm, _idx) {
          elm.remove()
        })
      }
      // FOR SINGLE UPLOAD, CLEAR TEMPLATE FIRST

      [...e.target.files].forEach((file, idx) => {
        const url  = URL.createObjectURL(file)
        const tmpl = document.querySelector('#receipt-template').content.cloneNode(true)
        tmpl.querySelector('img').src = url
        tmpl.querySelector('img').alt = file.name

        // ADDING ID TO HANDLER REMOVE VALUE
        let fileId = `${file.name}-${idx}`
        tmpl.querySelector('img').dataset.fileId = fileId
        file.id = fileId
        // ADDING ID TO HANDLER REMOVE VALUE

        tmpl.querySelector('.remove-topup').addEventListener('click', e => {
          // HANDLE CLICK BUTTON WILL REMOVE VALUE
          let imgId = e.target.closest('.receipt-itm').querySelector('img').dataset.fileId
          let newFileList = new DataTransfer();
          let inputFile = document.querySelector('#topup-confirm-upload');
          [...inputFile.files].forEach((file, idx) => {
            if (file.id != imgId) {
              console.log(file, 'file')
              newFileList.items.add(file)
            }
          })
          inputFile.files = newFileList.files;
          // HANDLE CLICK BUTTON WILL REMOVE VALUE

          e.target.closest('.receipt-itm').remove()
        })
        document.querySelector('#receipt-list').appendChild(tmpl)

        if (e.target.multiple) {
          list.items.add(file)
        }
      })

      // RESET CALCULATION FOR MULTIPLE UPLOAD
      if (e.target.multiple) {
        e.target.files = list.files;
        oldFiles = [];
        list = new DataTransfer()
      }
      // RESET CALCULATION FOR MULTIPLE UPLOAD
    })
  }

  const receiptList = document.querySelector('#receipt-list')
  if (receiptList) {
    const topUpProof = receiptList.dataset['topUpProof']
    if (topUpProof != '') {
      JSON.parse(topUpProof).forEach((url) => {
        const tmpl = document.querySelector('#receipt-template').content.cloneNode(true)
        tmpl.querySelector('img').src = url
        tmpl.querySelector('img').alt = 'image'

        tmpl.querySelector('.remove-topup').addEventListener('click', e => {
          e.target.closest('.receipt-itm').remove()
        })
        document.querySelector('#receipt-list').appendChild(tmpl)
      })
    }
  }
})